module.exports = __webpack_public_path__ + "assets/img/thumb-openinvest-get-started.a2527bdb.webp";